"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IWorkoutPhase = void 0;
var IWorkoutPhase;
(function (IWorkoutPhase) {
    IWorkoutPhase["Pre"] = "pre";
    IWorkoutPhase["Warmup"] = "warmup";
    IWorkoutPhase["Main"] = "main";
    IWorkoutPhase["Cooldown"] = "cooldown";
    IWorkoutPhase["Post"] = "post";
})(IWorkoutPhase || (exports.IWorkoutPhase = IWorkoutPhase = {}));
//# sourceMappingURL=workout-phase.js.map